import { render, staticRenderFns } from "./SearchExpired.vue?vue&type=template&id=1cdf5293&"
import script from "./SearchExpired.vue?vue&type=script&lang=js&"
export * from "./SearchExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports